/**
 * Keep these colors in sync with what is in tailwind.config.js
 */
export const WHITE = '#FFFFFF';
export const MOONBEAM = '#F1EFF8';
export const OBLIVION = '#0D0F12';

export const MOON_50 = '#FDFDFD';
export const MOON_100 = '#F8F8F8';
export const MOON_150 = '#F0F0F0';
export const MOON_200 = '#E8E8E9';
export const MOON_250 = '#DFE0E2';
export const MOON_300 = '#D4D5D9';
export const MOON_350 = '#C5C7CC';
export const MOON_400 = '#B1B4B9';
export const MOON_450 = '#8F949E';
export const MOON_500 = '#79808A';
export const MOON_550 = '#676D78';
export const MOON_600 = '#565C66';
export const MOON_650 = '#4B535C';
export const MOON_700 = '#3F464F';
export const MOON_750 = '#363C44';
export const MOON_800 = '#2B3038';
export const MOON_850 = '#20242B';
export const MOON_900 = '#1A1D24';
export const MOON_950 = '#171A1F';
export const MOONS = {
  MOON_50,
  MOON_100,
  MOON_150,
  MOON_200,
  MOON_250,
  MOON_300,
  MOON_350,
  MOON_400,
  MOON_450,
  MOON_500,
  MOON_550,
  MOON_600,
  MOON_650,
  MOON_700,
  MOON_750,
  MOON_800,
  MOON_850,
  MOON_900,
  MOON_950,
};

export const TEAL_200 = '#E1F7FA';
export const TEAL_300 = '#A9EDF2';
export const TEAL_350 = '#88E4EB';
export const TEAL_400 = '#58D3DB';
export const TEAL_450 = '#10BFCC';
export const TEAL_500 = '#13A9BA';
export const TEAL_550 = '#0097AB';
export const TEAL_600 = '#038194';
export const TEAL_650 = '#096A7A';
export const TEAL_700 = '#155B69';
export const TEAL_800 = '#18454E';
export const NEW_TEALS = {
  TEAL_200,
  TEAL_300,
  TEAL_350,
  TEAL_400,
  TEAL_450,
  TEAL_500,
  TEAL_550,
  TEAL_600,
  TEAL_650,
  TEAL_700,
  TEAL_800,
};
export const GREEN_300 = '#A1F0CB';
export const GREEN_350 = '#85E5BC';
export const GREEN_400 = '#5ED6A4';
export const GREEN_450 = '#28C787';
export const GREEN_500 = '#00B26E';
export const GREEN_550 = '#009962';
export const GREEN_600 = '#00875A';
export const GREEN_650 = '#0B7052';
export const GREEN_700 = '#165745';
export const NEW_GREENS = {
  GREEN_300,
  GREEN_350,
  GREEN_400,
  GREEN_450,
  GREEN_500,
  GREEN_550,
  GREEN_600,
  GREEN_650,
  GREEN_700,
};

export const CACTUS_300 = '#D0ED9D';
export const CACTUS_350 = '#C6EB83';
export const CACTUS_400 = '#BBE06B';
export const CACTUS_450 = '#A5D154';
export const CACTUS_500 = '#92C23A';
export const CACTUS_550 = '#7AA638';
export const CACTUS_600 = '#5F8A2D';
export const CACTUS_650 = '#496B22';
export const CACTUS_700 = '#3D541D';
export const NEW_CACTUSES = {
  CACTUS_300,
  CACTUS_350,
  CACTUS_400,
  CACTUS_450,
  CACTUS_500,
  CACTUS_550,
  CACTUS_600,
  CACTUS_650,
  CACTUS_700,
};

export const GOLD_300 = '#FFE49E';
export const GOLD_350 = '#FFDD80';
export const GOLD_400 = '#FFCF4D';
export const GOLD_450 = '#FAC13C';
export const GOLD_500 = '#F5A822';
export const GOLD_550 = '#D4870D';
export const GOLD_600 = '#B8740F';
export const GOLD_650 = '#8F5E14';
export const GOLD_700 = '#694919';
export const NEW_GOLDS = {
  GOLD_300,
  GOLD_350,
  GOLD_400,
  GOLD_450,
  GOLD_500,
  GOLD_550,
  GOLD_600,
  GOLD_650,
  GOLD_700,
};

export const SIENNA_300 = '#FFCFB2';
export const SIENNA_350 = '#FFBA91';
export const SIENNA_400 = '#FCA36F';
export const SIENNA_450 = '#FC8F58';
export const SIENNA_500 = '#F27641';
export const SIENNA_550 = '#D96534';
export const SIENNA_600 = '#C2562F';
export const SIENNA_650 = '#994228';
export const SIENNA_700 = '#703726';
export const NEW_SIENNAS = {
  SIENNA_300,
  SIENNA_350,
  SIENNA_400,
  SIENNA_450,
  SIENNA_500,
  SIENNA_550,
  SIENNA_600,
  SIENNA_650,
  SIENNA_700,
};

export const RED_300 = '#FFC7CA';
export const RED_350 = '#FFA8B0';
export const RED_400 = '#FF7A88';
export const RED_450 = '#FF596D';
export const RED_500 = '#FF3D5A';
export const RED_550 = '#E3324F';
export const RED_600 = '#CC2944';
export const RED_650 = '#A32740';
export const RED_700 = '#782637';
export const NEW_REDS = {
  RED_300,
  RED_350,
  RED_400,
  RED_450,
  RED_500,
  RED_550,
  RED_600,
  RED_650,
  RED_700,
};

export const MAGENTA_300 = '#EFC2FC';
export const MAGENTA_350 = '#E7A7FC';
export const MAGENTA_400 = '#E180FF';
export const MAGENTA_450 = '#D869FA';
export const MAGENTA_500 = '#CB51F0';
export const MAGENTA_550 = '#BC45E5';
export const MAGENTA_600 = '#9E36C2';
export const MAGENTA_650 = '#7A2C94';
export const MAGENTA_700 = '#602973';
export const NEW_MAGENTAS = {
  MAGENTA_300,
  MAGENTA_350,
  MAGENTA_400,
  MAGENTA_450,
  MAGENTA_500,
  MAGENTA_550,
  MAGENTA_600,
  MAGENTA_650,
  MAGENTA_700,
};

export const PURPLE_300 = '#D6C9FF';
export const PURPLE_350 = '#C2B1FC';
export const PURPLE_400 = '#B199FF';
export const PURPLE_450 = '#9D80FF';
export const PURPLE_500 = '#8465F0';
export const PURPLE_550 = '#7251E0';
export const PURPLE_600 = '#6645D1';
export const PURPLE_650 = '#5539B2';
export const PURPLE_700 = '#4B3791';
export const NEW_PURPLES = {
  PURPLE_300,
  PURPLE_350,
  PURPLE_400,
  PURPLE_450,
  PURPLE_500,
  PURPLE_550,
  PURPLE_600,
  PURPLE_650,
  PURPLE_700,
};

export const BLUE_300 = '#BDD9FF';
export const BLUE_350 = '#A4C9FC';
export const BLUE_400 = '#7DB1FA';
export const BLUE_450 = '#629DF5';
export const BLUE_500 = '#397EED';
export const BLUE_550 = '#286CE0';
export const BLUE_600 = '#1F59C4';
export const BLUE_650 = '#19469E';
export const BLUE_700 = '#193C80';
export const NEW_BLUES = {
  BLUE_300,
  BLUE_350,
  BLUE_400,
  BLUE_450,
  BLUE_500,
  BLUE_550,
  BLUE_600,
  BLUE_650,
  BLUE_700,
};

// Don't know if we ultimately want this here. This is copied from
// color.ts runColorDict in the W&B code. But I reordered them.

export const WB_RUN_COLORS = [
  '#5387DD',
  '#E87B9F',
  '#DA4C4C',
  '#A0C75C',
  '#F0B899',
  '#E57439',
  '#EDB732',
  '#87CEBF',
  '#229487',
  '#7D54B2',
  '#C565C7',
  '#A46750',
  '#A1A9AD',
  '#5BC5DB',
  '#A12864',
  '#479A5F',
];

export const THEME = {
  bgPage: 'var(--wb-bg-page)',
  bgSurface: 'var(--wb-bg-surface)',
  bgSurfaceRaised: 'var(--wb-bg-surface-raised)',
  bgSurfaceSunken: 'var(--wb-bg-surface-sunken)',
  bgSurfaceTint: 'var(--wb-bg-surface-tint)',
  bgHover: 'var(--wb-bg-hover)',
  bgHoverSolid: 'var(--wb-bg-hover-solid)',
  bgSelected: 'var(--wb-bg-selected)',
  bgBackdrop: 'var(--wb-bg-backdrop)',
  bgInverse: 'var(--wb-bg-inverse)',
  textPrimary: 'var(--wb-text-primary)',
  textSecondary: 'var(--wb-text-secondary)',
  textTertiary: 'var(--wb-text-tertiary)',
  textDisabled: 'var(--wb-text-disabled)',
  textInverse: 'var(--wb-text-inverse)',
  textLink: 'var(--wb-text-link)',
  textLinkHover: 'var(--wb-text-link-hover)',
  border: 'var(--wb-border)',
  borderStrong: 'var(--wb-border-strong)',
  divider: 'var(--wb-divider)',
  accent: 'var(--wb-accent)',
  accentHover: 'var(--wb-accent-hover)',
  accentBg: 'var(--wb-accent-bg)',
  accentText: 'var(--wb-accent-text)',
  statusErrorText: 'var(--wb-status-error-text)',
  statusErrorBg: 'var(--wb-status-error-bg)',
  statusErrorBorder: 'var(--wb-status-error-border)',
  statusWarningText: 'var(--wb-status-warning-text)',
  statusWarningBg: 'var(--wb-status-warning-bg)',
  statusWarningBorder: 'var(--wb-status-warning-border)',
  statusSuccessText: 'var(--wb-status-success-text)',
  statusSuccessBg: 'var(--wb-status-success-bg)',
  statusSuccessBorder: 'var(--wb-status-success-border)',
  statusInfoText: 'var(--wb-status-info-text)',
  statusInfoBg: 'var(--wb-status-info-bg)',
  statusInfoBorder: 'var(--wb-status-info-border)',
  shadowSm: 'var(--wb-shadow-sm)',
  shadowMd: 'var(--wb-shadow-md)',
  shadowLg: 'var(--wb-shadow-lg)',
} as const;
